module.exports = __webpack_public_path__ + "img/29.43239d07.gif";